<template>
    <div class="gas_instant">
        <el-form label-width="60px" :model="searchForm" class="leader-style-form">
            <el-form-item label="时间">
                <el-date-picker
                    v-model="searchForm.from_date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="disableDate"
                    :clearable="false"
                    :editable="false"
                ></el-date-picker>
                <span style="color: #fff;display: inline-block; padding: 0 20px">至</span>
                <el-date-picker
                    v-model="searchForm.to_date"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="disableDate"
                    :clearable="false"
                    :editable="false"
                ></el-date-picker>
                <!-- <el-date-picker
                    v-model="searchForm.time"
                    type="date"
                    placeholder="选择日期"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    :picker-options="disableDate"
                    :clearable="false"
                    :editable="false"
                >
                </el-date-picker>
                <el-button class="leader-common-button" @click="lastDay"
                    >上一日</el-button
                >
                <el-button
                    class="leader-common-button"
                    :disabled="this.sysDate === this.searchForm.time"
                    @click="nextDay"
                    >下一日</el-button
                >-->
                <el-button
                    type="primary"
                    size="medium"
                    class="leader-common-button"
                    @click="search"
                >查询</el-button>
            </el-form-item>
        </el-form>

        <div class="tab_cont">
            <el-radio-group v-model="tabVal" @change="tabChange" class="leader-radio">
                <el-radio-button
                    v-for="val in gasButtons"
                    :key="val.point_class_column_kind_id"
                    :label="val.point_class_column_kind_id"
                >{{ val.kind_name }}</el-radio-button>
            </el-radio-group>
            <div class="btn_cont">
                <el-button
                    icon="el-icon-menu"
                    class="leader-common-button"
                    @click="tableSwitch = true"
                >图表</el-button>
                <el-button
                    icon="el-icon-date"
                    class="leader-common-button"
                    @click="tableSwitch = false"
                >数据</el-button>
            </div>
        </div>
        <div class="chart_cont">
            <div
                class="echart-container"
                v-if="this.tableSwitch"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
            >
                <v-chart :auto-resize="true" :options="line" ref="line" />
            </div>
            <div class="table-container" v-if="!this.tableSwitch">
                <el-scrollbar style="height: 100%">
                    <el-table
                        :data="tableData"
                        border
                        v-loading="Tloading"
                        class="leader-style-table"
                    >
                        <el-table-column
                            v-for="val in tableHeader"
                            :key="val.column_val"
                            :prop="val.column_val"
                            :label="val.column_key"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </el-scrollbar>
            </div>
        </div>
    </div>
</template>
<script>
import "echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/dataZoom";
import * as api from "../../../../http/Use_electricity_monitor";
import moment from "moment";
import utils from "@/utils/utils.js";
export default {
    props: {
        id: {
            type: String,
        }
    },
    data() {
        return {
            gasButtons: [],
            searchForm: {
                from_date: "",
                to_date: ""
            },
            tabVal: "",
            loading: false,
            disableDate: {
                disabledDate: time => {
                    return (
                        time.getTime() >
                        new Date(
                            new Date(this.sysDate).toLocaleDateString()
                        ).getTime()
                    );
                }
            },
            x_list: [],
            series: [],
            legend: [],
            unit: "",
            sysDate: "",
            tableData: [],
            tableHeader: [],
            tableD: false,
            tableSwitch: true,
            Tloading: false
        };
    },
    watch: {
        id: {
            handler(newVal) {
                this.getSysDate();
            },
            // deep: true,
            // immediate: true
        }
    },
    methods: {
        // 获取类型
        getPointColumnKinds(point_id) {
            api.getPointColumnKinds({ point_id: point_id }).then(res => {
                if (res && res.error_code == "0") {
                    this.gasButtons = res.bus_json;
                    this.tabVal = res.bus_json[0].point_class_column_kind_id;
                    this.getRealTimeData(this.tabVal);
                }
            });
        },
        // 获取实时数据
        getRealTimeData(point_class_column_kind_id) {
            api.getRealTimeData({
                from_date: this.searchForm.from_date,
                to_date: this.searchForm.to_date,
                point_id: this.id,
                point_class_column_kind_id: point_class_column_kind_id
            }).then(res => {
                if (res && res.error_code === "0") {

                    this.x_list = res.bus_json.x_list;
                    // 数据
                    this.series = [];
                    // 图例
                    this.legend = [];

                    // 表格头部
                    this.tableHeader = [
                        {
                            column_key: "采集时间",
                            column_val: "time"
                        }
                    ];
                    res.bus_json.y_list.forEach(item => {
                        let everyData = {
                            name: item.column_desc,
                            type: "line",
                            data: item.dataList,
                            itemStyle: {
                                color: item.column_color
                            },
                            smooth: true,
                            symbol: "none"
                        };
                        this.unit = item.column_unit;
                        this.legend.push(item.column_desc);
                        this.series.push(everyData);
                        // 表格
                        let header_obj = {
                            column_key: item.column_desc,
                            column_val: item.column_name
                        };
                        this.tableHeader.push(header_obj);
                    });

                    //  表格
                    this.tableData = [];
                    this.x_list.forEach((V, index) => {
                        let data_obj = {
                            time: V
                        };
                        res.bus_json.y_list.forEach(T => {
                            data_obj[T.column_name] = T.dataList[index];
                        });
                        this.tableData.push(data_obj);
                    });

                }
            });
        },

        search() {
            this.getRealTimeData(this.tabVal);
        },
        //获取系统时间
        getSysDate() {
            api.getSysDate({}).then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.from_date = res.bus_json.sysdate;
                    this.searchForm.to_date = res.bus_json.sysdate;
                    this.sysDate = res.bus_json.sysdate;
                    this.getPointColumnKinds(this.id);
                }
            });
        },
        // tab切换触发事件
        tabChange(point_class_column_kind_id) {
            this.tabVal = point_class_column_kind_id;
            this.getRealTimeData(point_class_column_kind_id);
        }
    },
    computed: {
        line() {
            const options = {
                // title: {
                //     text: "瞬时量趋势分析"
                // },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: this.legend,
                    textStyle: {
                        color: "#fff"
                    }
                },
                calculable: true,
                xAxis: {
                    data: this.x_list,
                    axisLabel: {
                        // interval: 0, //横轴信息全部显示
                        rotate: -40, //-30度角倾斜显示
                        //y轴文字的配置
                        textStyle: {
                            color: "#fff" //颜色
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#fff" // 颜色
                        }
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: `单位：${this.unit}`,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor() //颜色
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                dataZoom: [
                    {
                        type: "inside", //图表下方的伸缩条
                        show: true, //是否显示
                        realtime: true, //拖动时，是否实时更新系列的视图
                        start: 0, //伸缩条开始位置（1-100），可以随时更改
                        end: 100 //伸缩条结束位置（1-100），可以随时更改
                    }
                ],
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "15%",
                    containLabel: true
                },
                series: this.series,
                color: ["#fee098", "#3abd69", "#fe7f65", "#aeaeae"]
            };
            return options;
        }
    },

    created() {
        this.getSysDate();
    }
};
</script>
<style lang="scss">
.gas_instant {
    width: 98%;
    padding-left: px2Rem(13px);

    .tab_cont {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .chart_cont {
        width: 100%;
        margin-top: px2Rem(30px);
        .echart-container {
            width: 100%;
            min-height: px2Rem(600px);
            .echarts {
                width: 100%;
                height: px2Rem(500px);
            }
        }
        .table-container {
            width: 100%;
            height: px2Rem(600px);
        }
    }
}
</style>
